import api from "../api/axios";

export const getVATReport = async (startDate, endDate) => {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  
  const response = await api.get("/reports/vat", { params });
  return response.data;
};
